// @flow

import { useState } from 'react'
import type { ValidationResult } from '@bil0-dr-bill/dr-bill-core'
import { capitalizeFirstLetter } from './utils.js'

type OnChangeFn = (string) => ValidationResult
type OnBlurFn = (string) => ValidationResult
type ValidatorFn = (string) => ValidationResult
type SetIsValidFn = (boolean) => Object
type SetValueFn = (string) => Object

export function useValidationResult(validator: ValidatorFn): [Object, OnChangeFn, OnBlurFn] {
  const [validationResult, setValidationResult] = useState({
    is_success: true,
    results: [],
  })

  const onChange = (newValue: string): ValidationResult => {
    let newResult: ValidationResult = validateField(newValue)

    setValidationResult(newResult)
    return newResult
  }

  const onBlur = (newValue: string): ValidationResult => {
    let newResult: ValidationResult = validateField(newValue)

    setValidationResult(newResult)
    return newResult
  }

  const validateField = (val: string) => {
    let newResult: ValidationResult

    newResult = validator(val)
    return newResult
  }

  return [validationResult, onChange, onBlur]
}

export function getErrorMsg(validationResult: ValidationResult): string {
  if (validationResult.is_success) {
    return ''
  }

  const firstUnmetCriterion = validationResult.results.filter((r) => !r.is_success)[0]

  if (firstUnmetCriterion) {
    return capitalizeFirstLetter(firstUnmetCriterion.error_message)
  } else {
    return ''
  }
}

export function handleBlur(value: string, onBlur: OnBlurFn, setIsValid: SetIsValidFn) {
  const newResult = onBlur(value)

  setIsValid(newResult.is_success)
}

export function handleChange(
  value: string,
  onChange: OnChangeFn,
  setIsValid: SetIsValidFn,
  setValue: SetValueFn
) {
  const newResult = onChange(value)

  setIsValid(newResult.is_success)
  setValue(value)
}
